import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from './contexts/authContext';
import ReactGA from 'react-ga4';

import { UserInputProvider } from './contexts/UserInputContext';
import { ThemeProvider } from './contexts/ThemeContext';

import MainPage from './pages/MainPage';
import HomePage from './pages/HomePage';
import PurposePage from './pages/PurposePage';
import InputPage from './pages/InputPage';
import TonePage from './pages/TonePage';
import ResultPage from './pages/ResultPage';
import HistoryPage from './pages/HistoryPage';
import FeedbackPage from './pages/FeedbackPage';
import NotFoundPage from './pages/NotFoundPage';
import ChatPage from './pages/ChatPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import MyPage from './pages/MyPage';
import AdminPage from "./pages/AdminPage";
import FeedbackForm from "./components/FeedbackForm";
import FeedbackAdminPage from "./pages/FeedbackAdminPage";
import { AuthProvider } from "./contexts/authContext";

import Header from './components/Header';
import VerifySentPage  from './components/VerifySentPage';
import ScreenTranslatorPage from "./pages/ScreenTranslatorPage";
import PdfUpload from "./pages/PdfUpload";
import CalcHelper from "./pages/CalcHelper";
import BrainTrainerPage from "./pages/BrainTrainerPage";
import BrainAgePage from "./pages/BrainAgePage";
import BrainAgeHistoryPage from "./pages/BrainAgeHistoryPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import DeleteAccountPage from "./pages/DeleteAccountPage";
import InquiryPage from "./pages/InquiryPage";
import AdminInquiriesPage from "./pages/AdminInquiriesPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PurchasePage from "./pages/PurchasePage";
import PurchaseSuccess from "./pages/PurchaseSuccess";
import PurchaseFail from "./pages/PurchaseFail";
import UsagePage from "./pages/UsagePage";
import { initAnonymous } from "./api/anonClient";


// 페이지 이동 시 GA 이벤트 전송
function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
      ReactGA.send({ hitType: 'pageview', page: location.pathname });
    }, [location]);
  }

function AppWrapper() {
  const { isLoggedIn, setIsLoggedIn } = useAuth();
  const location = useLocation();

  document.body.classList.add('dark');

  // 로그인 상태 체크 (localStorage에서 토큰 확인)
  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
  }, []);

  document.body.classList.add('dark');

  const hideHeaderPaths = ['/', '/chat','/login'];
  const allPagePaths = [
    '/', '/chat', '/feedback', '/home', '/purpose', '/input',
    '/tone', '/result', '/history', '/templates', '/profile'
  ];

  const isNotFoundPage = !allPagePaths.includes(location.pathname);
  const shouldShowHeader = !hideHeaderPaths.includes(location.pathname) && !isNotFoundPage;

  usePageTracking();

  return (
    <>
       {shouldShowHeader && (
        <Header
        />
      )}

      <Routes>
        <Route path="/" element={<MainPage />} />
         {/* chat 경로 추가 */}
        <Route path="/chat" element={<ChatPage />} />
        {/* feedback 경로 추가 */}
        <Route path="/feedback" element={<FeedbackForm />} />
        <Route path="/jw/feedbacks" element={<FeedbackAdminPage />} />
        <Route path="/jw/pdfupload" element={<PdfUpload />} />
        <Route path="/admin" element={<AdminPage />} />

        <Route path="/home" element={<HomePage />} />
        <Route path="/purpose" element={<PurposePage />} />
        <Route path="/input" element={<InputPage />} />
        <Route path="/tone" element={<TonePage />} />
        <Route path="/result" element={<ResultPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/feedback" element={<FeedbackPage />} />

        {/* 로그인/회원가입/프로필 경로 추가 */}
        <Route path="/login" element={<LoginPage/>} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/verify-sent" element={<VerifySentPage />} />


        {/* NotFoundPage 경로 추가 */}
        <Route path="*" element={<NotFoundPage />} />

        {/* calc-helper 경로 추가 */}
        <Route path="/calc-helper" element={<CalcHelper />} />
        {/* brain-trainer 경로 추가 */}
        <Route path="/brain-trainer" element={<BrainTrainerPage />} />
        <Route path="/brain-age" element={<BrainAgePage />} />

        {/* mypage 내에 경로 추가 */}
        <Route path="/mypage" element={<MyPage />} />
        <Route path="/brain-age-history" element={<BrainAgeHistoryPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
        <Route path="/delete-account" element={<DeleteAccountPage />} />
        <Route path="/usage" element={<UsagePage />} />

        {/* 1:1문의 관련 경로 추가 */}
        <Route path="/inquiry" element={<InquiryPage />} />
        <Route path="/admin/inquiries" element={<AdminInquiriesPage />} />

        {/* 결제 관련 경로 추가 */}
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/purchase" element={<PurchasePage />} />
        <Route path="/purchase/success" element={<PurchaseSuccess />} />
        <Route path="/purchase/fail" element={<PurchaseFail />} />

        {/* screen-translator 경로 추가 */}
        <Route path="/screen-translator" element={<ScreenTranslatorPage />} />
      </Routes>
    </>
  );
}

function App() {
  useEffect(() => {
    (async () => {
      try {
        await initAnonymous();
      } catch (e) {
        console.error("[anon init] failed:", e);
      }
    })();
  }, []);


  return (
    <AuthProvider>
      <ThemeProvider>
        <UserInputProvider>
          <Router>
            <AppWrapper />
          </Router>
        </UserInputProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
